import { get } from 'lodash-es';
import { PlatformKey } from '@/constants';

export enum AgeRestriction {
  MINOR_IS_RESTRICT = 'minor_is_restrict',
  MINOR_NEED_CONSENT = 'minor_need_concent',
}

// TODO: create a vue plugin from these configs
const ui = {
  [PlatformKey.STAN]: {
    signup: {
      ageRestriction: AgeRestriction.MINOR_IS_RESTRICT,
    },
  },

  [PlatformKey.IRIGO]: {
    profil: {
      showNewsletterSwitch: false,
    },
  },

  [PlatformKey.ASTUCE]: {
    signup: {
      enableMultipleRegister: false,
    },
  },

  [PlatformKey.BKLUB]: {
    profil: {
      showNewsletterSwitch: false,
    },
  },

  [PlatformKey.STAR]: {
    signup: {
      displayDOBInput: false,
      displayCGU: false,
    },
    profil: {
      showNewsletterSwitch: false,
      cardNumberIsEditable: false,
      externalUpdateUrl: true,
    },
    account: {
      deactivateLink: true,
      deleteLink: true,
    },
  },

  [PlatformKey.SISMO]: {
    profil: {
      cardNumberIsEditable: true,
    },
    contact: {
      customServiceDesk: true,
    },
  },

  [PlatformKey.CLUBEO]: {
    signup: {
      displayDOBInput: false,
      ageRestriction: AgeRestriction.MINOR_NEED_CONSENT,
    },
    profil: {
      showNewsletterSwitch: false,
      // cardNumberIsEditable est en commentaire pour permettre aux users de modifier leurs numéros de carte en attendant la mise en place du SSO
      // à remettre en place quand le SSO de Clubéo sera fini
      // cardNumberIsEditable: false,
    },
  },

  [PlatformKey.MOBICLUB]: {
    profil: {
      useRegex: false,
    },
  },

  [PlatformKey.SAMOBILITE]: {
    profil: {
      useRegex: false,
    },
    contact: {
      customServiceDesk: true,
    },
  },

  [PlatformKey.TWISTO]: {
    signup: {
      ageRestriction: AgeRestriction.MINOR_IS_RESTRICT,
    },
    profil: {
      useRegex: false,
    },
    contact: {
      customServiceDesk: true,
    },
  },

  [PlatformKey.LEKLUB]: {
    profil: {
      useRegex: false,
    },
    contact: {
      customServiceDesk: true,
    },
  },

  [PlatformKey.TAO]: {
    signup: {
      ageRestriction: AgeRestriction.MINOR_IS_RESTRICT,
    },
    profil: {
      useRegex: false,
    },
    contact: {
      customServiceDesk: true,
    },
  },

  [PlatformKey.STAS]: {
    signup: {
      ageRestriction: AgeRestriction.MINOR_IS_RESTRICT,
    },
    contact: {
      customServiceDesk: true,
    },
  },
  [PlatformKey.ECOMOTIVE]: {
    footer: {
      accessibilityReference: true,
    },
    contact: {
      customServiceDesk: true,
    },
  },
  [PlatformKey.TCL]: {
    contact: {
      customServiceDesk: true,
    },
  },
  default: {
    signup: {
      displayDOBInput: true,
      ageRestriction: AgeRestriction.MINOR_NEED_CONSENT,
      enableMultipleRegister: true,
      displayCGU: true,
    },

    profil: {
      showNewsletterSwitch: true,
      cardNumberIsEditable: true,
      externalUpdateUrl: false,
    },
    account: {
      deactivateLink: false,
      deleteLink: false,
    },
    contact: {
      customServiceDesk: false,
    },
    footer: {
      accessibilityReference: false,
    },
  },
};

export function getUIConfig(platformKey: PlatformKey, configKey: string) {
  const result = resolveConfig(platformKey, configKey);
  return result !== undefined ? result : resolveConfig('default', configKey);
}

function resolveConfig(platformKey: PlatformKey | 'default', configKey: string) {
  return get(ui, `${platformKey}.${configKey}`);
}
